/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentProtocolUpdateRequest
 */
export interface IncidentProtocolUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolUpdateRequest
     */
    name: string;
}

/**
 * Check if a given object implements the IncidentProtocolUpdateRequest interface.
 */
export function instanceOfIncidentProtocolUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function IncidentProtocolUpdateRequestFromJSON(json: any): IncidentProtocolUpdateRequest {
    return IncidentProtocolUpdateRequestFromJSONTyped(json, false);
}

export function IncidentProtocolUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentProtocolUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function IncidentProtocolUpdateRequestToJSON(value?: IncidentProtocolUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

